import { Button, ButtonContainer, Heading, Input, Layout } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { useRef } from "react";
import DealerService from "../../services/DealerService";
import { useAuth } from "../../hooks/useAuth";
import { Step } from "../../interfaces";

export const SearchDealer = () => {
    const { handleDataTemplateChange } = useAuth();
    const { submitAnswersRequest, goToPreviousStep, setIsLoading, setDealersList, setFirstSearch, isEdit } =
        useMatchMakerWizard();
    const { t } = useTranslation(["dealerselection"]);
    const search = useRef<HTMLInputElement>(null);
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const handleSearch = async () => {
        setIsLoading(true);
        const dealerservice = new DealerService();
        let searchValue: string = "";
        if (search && search.current && search.current && search.current.value) searchValue = search.current.value;
        try {
            setFirstSearch(false);
            const { status, data } = await dealerservice.getDealersSearch(
                `search=${searchValue}&brand=${process.env.REACT_APP_WEBSITE_BRAND}`
            );
            if (status !== 200) {
                setDealersList([]);
                setIsLoading(false);
                return;
            }

            handleDataTemplateChange(Step.DEALER_SELECTION, "pagechange", true, submitAnswersRequest);
            setDealersList(data);
        } catch {
            setDealersList([]);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Layout.Item default="3/4" m="2/3" s="1/1">
            <Heading level={3} className="u-font-size-fs3">{brand === "audi" ? t("dealerselection:dealer-search-section.titleAudi"): t("dealerselection:dealer-search-section.title")}</Heading>
            <Heading level={4} className="u-font-size-fs1">{brand === "audi" ? t("dealerselection:dealer-search-section.sub-titleAudi"): t("dealerselection:dealer-search-section.sub-title")}</Heading>
            <Input
                addonClickHandler={function noRefCheck() {}}
                addonElement="button"
                addonIcon="semantic-search"
                addonText="search"
                id="SearchDealer"
                placeholder={t("dealerselection:dealer-search-section.input-placeholder")}
                ref={search}
                autoComplete="postal-code"
            />
            <ButtonContainer nav className="u-mt">
                {!isEdit && (
                    <Button type="button" secondary onClick={goToPreviousStep}>
                        {t("dealerselection:dealer-search-section.back-button")}
                    </Button>
                )}

                <Button type="button" id="SubmitSearchDealer" onClick={handleSearch}>
                    {t("dealerselection:dealer-search-section.search-button")}
                </Button>
            </ButtonContainer>
        </Layout.Item>
    );
};
